import { TextField, Box } from '@mui/material';
import { useCaseFieldData, useCaseFieldDispatch } from '../../../hooks/useCaseField';
import type { FieldMode } from '../../../hooks/useCaseField';

interface PhysicianFieldProps {
  mode: FieldMode;
  company: string;
  centerId: string;
  errors?: { physician?: string; npi?: string };
}

const PhysicianField: React.FC<PhysicianFieldProps> = ({ mode, errors = {} }) => {
  const data = useCaseFieldData(mode);
  const { dispatchUpdate } = useCaseFieldDispatch(mode);

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 160px', gap: 1.5 }}>
      <TextField
        label="Physician Name" required size="small"
        value={data.physicianName}
        onChange={e => dispatchUpdate({ physicianName: e.target.value })}
        error={!!errors.physician} helperText={errors.physician}
      />
      <TextField
        label="NPI" required size="small"
        value={data.physicianNpi}
        onChange={e => dispatchUpdate({ physicianNpi: e.target.value })}
        error={!!errors.npi} helperText={errors.npi}
      />
    </Box>
  );
};

export default PhysicianField;
